module.exports = __webpack_public_path__ + "static/media/599.7554(34).b4e94f20.pdf";